import { NAME_SPACE } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const SET_MAP_BOUNDS = `${NAME_SPACE}SET_MAP_BOUNDS`;
